<div class="p-2 border rounded border-solid border-gray-300 dark:border-gray-500 uppercase text-lg text-gray-500">

  <div class="flex flex-col text-center">
    <h3 class="text-gray-500 dark:text-gray-50 font-bold text-base">Tarjeton - {{cruce.nombreSubtipo}}</h3>
    <hr class="mt-2 mb-2">

    <div class="grid grid-cols-2">

      <div class="col-start-1 w-96">

        <app-teclado-numerico (change)="onChangeTN($event)" (valueResponse)="recibiRespuesta($event)"
          [multipleInputs]="false" (confirmValue)="validateScanCode($event)"
          placeholder="No tarjeton"></app-teclado-numerico>

        <div class="mt-2">
          <button (click)="cancelAction()"
            class="bg-blue-600 p-3 w-full text-white font-bold uppercase border border-transparent hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">Cancelar</button>
        </div>

      </div>
      <div *ngIf="baseVehiculosExe" >

        <table style="width: 100%;">
          <tbody class="borderT" style="width: 100%; ">
            <tr>

              <td colspan="3" class="borderT" style="width: 60%; text-align: center; font-size: 30px; padding: 10px">
                TARIFA ESPECIAL <br> {{cruce.nombreSubtipo}} </td>

            </tr>
            <tr>
              <!--
                <td class="borderT" style="width: 50%; text-align: center; font-size: 100px" colspan="2">
                  <p>{{baseVehiculosExe?.no_tarjeton}}</p>
                </td>
              -->
              <td class="borderT" style="width: 50%; padding: 5px; text-align: left;">
                <p> {{ baseVehiculosExe?.persona ? (baseVehiculosExe.persona.nombre + ' ' + baseVehiculosExe.persona.apellido_paterno + ' ' + (baseVehiculosExe.persona.apellido_materno || '')).trim() : 'REGISTRO COMPLETO PENDIENTE' }}</p>
                <!--
                
                  <p> MARCA: {{baseVehiculosExe?.marca}}</p>
                  <p> COLOR: {{baseVehiculosExe?.color || 'N/A'}}</p>
                  <p> AÑO: {{baseVehiculosExe?.anio || 'N/A'}}</p>
                  <p> TIPO: {{baseVehiculosExe?.tipo || 'N/A'}}</p>
                  <p> LINEA: {{baseVehiculosExe?.linea || 'N/A'}}</p>
                  <p style="width: 50%; text-align: center; font-size: 30px"> {{baseVehiculosExe?.placa}} </p>
                  -->
              </td>
            </tr>
            <tr>
              <!--
                <td class="borderT" style="width: 20%;  font-size: 30px;  text-align: center; padding: 10px">DESCUENTO
                  {{baseVehiculosExe?.descuento.descuento}}%</td>
              -->
              <td class="borderT" style="width: 80%; text-align: left; padding: 10px" colspan="2">
                <p> VALIDO EN PLAZA: {{actualUser?.nom_caseta}}</p>
                <p> REGISTRO: {{baseVehiculosExe?.fecha_registro}}</p>
                <p> OBSERVACIONES:{{baseVehiculosExe?.observaciones || 'N/A'}}</p>
                
                <p> POBLADO: {{baseVehiculosExe?.poblado || 'N/A'}}</p>
              </td>

            </tr>
            <tr>
              <td colspan="3">
                <div class="mt-6 flex items-center justify-end gap-x-6">
                  <button
                    class="btn bg-gray-50 dark:bg-transparent rounded py-2 px-2 w-full  dark:text-gray-100  text-normal font-semibold border-2 border-gray-300 dark:border-gray-400 drop-shadow-lg hover:border-blue-600 uppercase"
                    (click)="saveScanCode()">Confirmar</button>

                </div>
              </td>
            </tr>
          </tbody>
        </table>

      </div>

      <!-- Validaciones para enviar a registro -->
      <!-- Validacion de envio a registro -->
      <!-- <div> -->
      <div *ngIf="confirmarRegistro">
        <table style="width: 100%;">
          <tbody class="borderT" style="width: 100%; ">
            <tr>
              <td colspan="3" class="borderT" style="width: 60%; text-align: center; font-size: 20px; padding: 10px">
                SI LA TARJETA FUNCIONO EN EL SISTEMA DE GESTION DE PEAJE <br> PRESIONE ENVIAR A REGISTRO </td>

            </tr>
            <tr>
              <td colspan="4">
                <div class="mt-6 flex items-center justify-end gap-x-6">
                  <button
                    class="btn bg-gray-50 dark:bg-transparent rounded py-2 px-2 w-full  dark:text-gray-100  text-normal font-semibold border-2 border-gray-300 dark:border-gray-400 drop-shadow-lg hover:border-blue-600 uppercase"
                    (click)="mandarRegistro()">ENVIAR A REGISTRO</button>

                </div>
              </td>
              <!--
                <td colspan="2">
                  <div class="mt-6 flex items-center justify-end gap-x-6">
                    <button
                      class="btn bg-gray-50 dark:bg-transparent rounded py-2 px-2 w-full  dark:text-gray-100  text-normal font-semibold border-2 border-gray-300 dark:border-gray-400 drop-shadow-lg hover:border-blue-600 uppercase"
                      (click)="cancelarRegistro()">CANCELAR</button>
  
                  </div>
                </td>
              -->
            </tr>
          </tbody>
        </table>
      </div>
      <!-- Validacion de Anotaciones del cajero -->
      <div *ngIf="confirmarAnotacionCajero">
        <table style="width: 100%;">
          <tbody class="borderT" style="width: 100%; ">
            <tr>
              <td colspan="3" class="borderT" style="width: 60%; text-align: center; font-size: 20px; padding: 10px">
                ANOTE EN SU BITACORA:
            </tr>
            <tr>
              <td colspan="3" class="borderT" style="width: 60%; text-align: center; font-size: 20px; padding: 10px">
                <p>NOMBRE DEL USUARIO (Identificacion del usuario)</p>
                <p>Orden de Evento = {{ this.numeroRandom }}</p>
            </tr>
            <tr>
              <td colspan="2">
                <div class="mt-6 flex items-center justify-end gap-x-6">
                  <button
                    class="btn bg-gray-50 dark:bg-transparent rounded py-2 px-2 w-full  dark:text-gray-100  text-normal font-semibold border-2 border-gray-300 dark:border-gray-400 drop-shadow-lg hover:border-blue-600 uppercase"
                    (click)="finalizarRegistro()">FINALIZAR</button>

                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>